export default [
  {
    prop: 'role_name',
    label: '角色名称',
    tooltip: true
  },
  {
    prop: 'describe',
    label: '描述',
    tooltip: true
  },
  {
    prop: 'action',
    width: '240px',
    label: '操作'
  }
]
